import {SearchModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";

export class CustomObjectAssociationContext {
    static readonly PRODUCT_LINE: string = "ProductLine";
    static readonly INVENTORY: string = "Inventory";
    static readonly OUTLET: string = "Outlet";
    static readonly MEMBERSHIP_TYPE: string = "MembershipType";
}

@Injectable()
export class CustomObjectTypeSearchModel extends SearchModel<any> {
    static readonly CONTEXT_FILTER_NAME: string = "customObjectContext";

    constructor(injector: Injector) {
        super(injector);
    }

    override getIdentifierField(): string {
        return "customObjectTypeId";
    }

    override isEntityLocalisable(): boolean {
        return false;
    }

    override getResourceName(): string {
        return "custom-object-type";
    }

    override getResource(): string {
        return "custom-group-type";
    }
}
